// Authed calls to backend/api/pipelinesApi.js, scoped to one pipeline.
import { apiGet, apiPost } from '../../utils/backendApi';

export function pipelineApi(orgId, workspaceId, pipelineId) {
  const base = `/orgs/${orgId}/ws/${workspaceId}/pipelines/${pipelineId}`;
  return {
    get: (path, params) => apiGet(`${base}${path}${params ? `?${new URLSearchParams(params)}` : ''}`),
    post: (path, body) => apiPost(`${base}${path}`, body || {}),
  };
}

export const shortSha = (s) => (/^[0-9a-f]{40}$/i.test(String(s || '')) ? String(s).slice(0, 10) : String(s || ''));

export async function copyText(text) {
  try { await navigator.clipboard.writeText(String(text)); return true; } catch { return false; }
}
